












































import { Vue, Component } from "vue-property-decorator";
import Modal from "@/components/shared/Modal.vue";

@Component<Tutorial>({
  components: {
    Modal,
  },
})
export default class Tutorial extends Vue {
  showModal = false;
}
